var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-header",
    { staticStyle: { height: "auto" } },
    [
      _c("el-container", { staticClass: "d-flex-center" }, [
        _c(
          "a",
          {
            staticClass: "nav-brand",
            attrs: { href: "javascript:void(0);" },
            on: {
              click: function($event) {
                _vm.$router.push("/")
              }
            }
          },
          [
            _c("img", {
              staticClass: "logo",
              attrs: {
                alt: "Maren Logo",
                src: require("../../../public/img/logo.svg"),
                width: "120"
              }
            })
          ]
        ),
        _c(
          "button",
          { staticClass: "toggle-menu", on: { click: _vm.toggle } },
          [_c("i", { staticClass: "icon-menu2" })]
        ),
        _c(
          "ul",
          { staticClass: "menu-list", class: _vm.open ? "block" : "hidden" },
          [
            _c(
              "li",
              { staticClass: "menu-item" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "menu-link phone-call",
                    attrs: { to: "/aboutus" }
                  },
                  [_vm._v("About Us")]
                )
              ],
              1
            ),
            _c(
              "li",
              { staticClass: "menu-item" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "menu-link phone-call",
                    attrs: { to: "/products" }
                  },
                  [_vm._v("Products")]
                )
              ],
              1
            ),
            _c(
              "li",
              { staticClass: "menu-item" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "menu-link phone-call",
                    attrs: { to: "/our-team" }
                  },
                  [_vm._v("Our Team")]
                )
              ],
              1
            ),
            _c(
              "li",
              { staticClass: "menu-item" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "menu-link phone-call",
                    attrs: { to: "/awards-events" }
                  },
                  [_vm._v("Awards & Events")]
                )
              ],
              1
            ),
            _c(
              "li",
              { staticClass: "menu-item" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "menu-link phone-call",
                    attrs: { to: "/memories" }
                  },
                  [_vm._v("Memories")]
                )
              ],
              1
            ),
            _c(
              "li",
              { staticClass: "menu-item" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "menu-link phone-call",
                    attrs: { to: "/careers" }
                  },
                  [_vm._v("Careers")]
                )
              ],
              1
            ),
            _c(
              "li",
              { staticClass: "menu-item" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "menu-link phone-call",
                    attrs: { to: "/contactus" }
                  },
                  [_vm._v("Contact Us")]
                )
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/Header.vue?vue&type=template&id=1f234af1&
// module id = 322
// module chunks = 10